
import { Button } from "@/components/ui/button";

const steps = [
  {
    number: "01",
    title: "Space Assessment",
    description: "We evaluate your property to identify optimal locations for Quiet Corner pods, ensuring they enhance your space without disruption.",
  },
  {
    number: "02",
    title: "Seamless Installation",
    description: "Our team handles everything from delivery to setup with minimal disruption to your operations. Installation typically takes less than a day.",
  },
  {
    number: "03",
    title: "Revenue Activation",
    description: "Once installed, pods become immediately available on our booking platform, ready to generate revenue for your property.",
  },
  {
    number: "04",
    title: "Management & Maintenance",
    description: "We remotely monitor usage, handle all bookings, and maintain the pods—allowing you to enjoy additional revenue with zero operational burden.",
  },
];

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-primary text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-montserrat text-3xl md:text-4xl font-extrabold mb-4">
            How Quiet Corner Works for Property Owners
          </h2>
          <p className="text-lg text-white/90 max-w-2xl mx-auto">
            
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-primary border border-accent/30 rounded-xl p-8 h-full hover:bg-primary/80 transition-colors duration-300">
                <div className="text-orange text-4xl font-bold mb-4">{step.number}</div>
                <h3 className="text-xl font-semibold mb-3">{step.title}</h3>
                <p className="text-white/90">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 w-8 h-[2px] bg-orange/50"></div>
              )}
            </div>
          ))}
        </div>

        {/* Added extra padding-top (pt-24) and scroll margin to ensure visibility when navigating */}
        <div id="experience" className="mt-16 pt-6 md:pt-10 bg-white/10 rounded-xl p-8 border border-white/20 scroll-mt-24">
          <div className="text-center mb-8">
            <h3 className="font-montserrat text-2xl font-extrabold mb-2">The Quiet Corner Experience</h3>
            <p className="text-white/90">Here's what our pods offer to end users who book them:</p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            <div className="bg-white/15 p-6 rounded-lg">
              <h4 className="text-lg font-medium mb-2">Acoustic Privacy</h4>
              <p className="text-white/90 text-sm">
                Sound-dampening materials create a distraction-free environment for calls and focused work.
              </p>
            </div>
            <div className="bg-white/15 p-6 rounded-lg">
              <h4 className="text-lg font-medium mb-2">Smart Access</h4>
              <p className="text-white/90 text-sm">
                Secure entry with one-tap payment via smartphone or CC for sessions ranging from 30 minutes to several hours.
              </p>
            </div>
            <div className="bg-white/15 p-6 rounded-lg">
              <h4 className="text-lg font-medium mb-2">Productivity Setup</h4>
              <p className="text-white/90 text-sm">
                Ergonomic desk, charging ports, and high-speed Wi-Fi to keep professionals productive.
              </p>
            </div>
            <div className="bg-white/15 p-6 rounded-lg">
              <h4 className="text-lg font-medium mb-2">Booking Capabilities</h4>
              <p className="text-white/90 text-sm">
                Book time in Quiet Corner in advance of your meetings with the app or on-demand at the booth.
              </p>
            </div>
            <div className="bg-white/15 p-6 rounded-lg">
              <h4 className="text-lg font-medium mb-2">Easily Moveable</h4>
              <p className="text-white/90 text-sm">
                Delivered with retractable wheels for easy relocation within property by a single person.
              </p>
            </div>
            <div className="bg-white/15 p-6 rounded-lg">
              <h4 className="text-lg font-medium mb-2">Elegant Design</h4>
              <p className="text-white/90 text-sm">
                High-end finishes that complement your property's aesthetic with a modern, minimal look.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
